<script setup lang="ts">
import { FEATURE_PAGES } from '~/constants/featurePages'

/**
 * Ported from the template's service grid: heading on the left, one button on
 * the right, then flat white cards that lift on hover with a sliding arrow.
 */
const { t } = useI18n()
</script>

<template>
  <section class="sofax surface-alt">
    <div class="section-space">
      <div class="shell">
        <div class="mb-14 flex flex-wrap items-center justify-between gap-8 lg:mb-20">
          <div class="max-w-3xl">
            <h2>{{ t('marketing.featureLinks.title') }}</h2>
          </div>
          <SofaxBtn to="/pricing" :label="t('marketing.featureLinks.pricingCta')" variant="dark" />
        </div>

        <ul class="grid grid-cols-1 gap-x-6 gap-y-8 md:grid-cols-2 lg:grid-cols-3">
          <li v-for="page in FEATURE_PAGES" :key="page.id">
            <LocaleLink
              :to="page.path"
              class="group block h-full rounded-[0.625rem] bg-white p-[1.875rem] transition-all duration-300 hover:shadow-lift dark:bg-gray-800"
            >
              <!-- The template's own illustrated icon; its line art is dark,
                   so the tile stays light in dark mode as well. -->
              <span class="inline-flex size-20 items-center justify-center rounded-[0.625rem] bg-surface">
                <img :src="page.illustration" alt="" aria-hidden="true" width="80" height="80" class="size-12" loading="lazy">
              </span>

              <div class="mb-4 mt-[1.875rem] font-title text-2xl font-bold -tracking-[0.5px] text-ink dark:text-white">
                {{ t(page.titleKey) }}
              </div>

              <p class="mb-[1.875rem] text-base">{{ t(page.descriptionKey) }}</p>

              <SofaxArrowLink as="span" :label="t('marketing.featureLinks.more')" />
            </LocaleLink>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
